/* TechTees accessibility layer for the frozen Minimog cart drawer, header cart link and predictive search (REQ-061).
   Plain script, no custom elements, nothing above the fold. The markup it relies on is registered in ops/CUSTOMIZATIONS.md. */
(function () {
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function visible(el) {
    return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';
  }
  function focusables(root) {
    return Array.prototype.filter.call(root.querySelectorAll(FOCUSABLE), visible);
  }
  function usable(el) {
    return el && el.isConnected && el !== document.body && visible(el);
  }

  /* A11Y-08: the header cart link says what it is and how many items it holds, and follows the count bubble. */
  function cartLabels() {
    var links = document.querySelectorAll('.m-cart-icon-bubble');
    if (!links.length) return;
    function sync() {
      var bubble = document.querySelector('.m-cart-count-bubble');
      var count = bubble && !bubble.classList.contains('m:hidden') ? parseInt(bubble.textContent, 10) || 0 : 0;
      links.forEach(function (link) {
        var tip = link.querySelector('.m-tooltip__content');
        var name = (tip && tip.textContent.trim()) || 'Cart';
        link.setAttribute('aria-label', name + ', ' + count + (count === 1 ? ' item' : ' items'));
      });
    }
    var observer = new MutationObserver(sync);
    document.querySelectorAll('.m-cart-count-bubble').forEach(function (bubble) {
      observer.observe(bubble, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    sync();
  }

  /* A11Y-01 and A11Y-21: the cart drawer behaves as a modal dialog. */
  function cartDrawer() {
    var drawer = document.getElementById('MinimogCartDrawer');
    if (!drawer) return;
    var ACTIVE = 'm-cart-drawer--active';
    var status = drawer.querySelector('[data-tt-drawer-status]');
    var lastOutside = null;
    var opener = null;
    var wasOpen = false;
    var resume = null;
    var pendingAnnounce = false;
    var announceTimer = 0;

    function isOpen() { return drawer.classList.contains(ACTIVE); }
    function inner() { return drawer.querySelector('.m-cart-drawer__inner') || drawer; }
    function closeButton() { return drawer.querySelector('.m-cart-drawer__close'); }

    function moveFocusIn() {
      var tries = 0;
      (function attempt() {
        if (!isOpen()) return;
        var target = closeButton() || focusables(inner())[0];
        if (target) target.focus({ preventScroll: true });
        if (!drawer.contains(document.activeElement) && tries++ < 10) setTimeout(attempt, 50);
      }());
    }

    document.addEventListener('focusin', function (event) {
      if (drawer.contains(event.target)) {
        if (isOpen()) resume = describe(event.target);
      } else if (!isOpen()) {
        lastOutside = event.target;
      }
    });

    /* The drawer re-renders its lines with innerHTML, which drops the focused control; remember it and put focus back. */
    function describe(el) {
      var qty = el.closest && el.closest('m-quantity-input');
      var input = qty && qty.querySelector('input');
      if (input) return { index: input.dataset.index, name: el.name === 'plus' || el.name === 'minus' ? el.name : 'input' };
      return null;
    }
    function restore() {
      if (!isOpen() || (document.activeElement && drawer.contains(document.activeElement) && document.activeElement !== drawer)) return;
      var target = null;
      if (resume) {
        var input = drawer.querySelector('input[data-index="' + resume.index + '"]');
        var qty = input && input.closest('m-quantity-input');
        if (qty) target = resume.name === 'input' ? input : qty.querySelector('button[name="' + resume.name + '"]');
      }
      target = target || closeButton();
      if (target) target.focus({ preventScroll: true });
    }

    new MutationObserver(function () {
      var open = isOpen();
      if (open === wasOpen) return;
      wasOpen = open;
      if (open) {
        opener = usable(lastOutside) ? lastOutside : document.querySelector('.m-cart-icon-bubble');
        moveFocusIn();
      } else {
        var active = document.activeElement;
        if ((!active || active === document.body || drawer.contains(active)) && usable(opener)) opener.focus({ preventScroll: true });
        resume = null;
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (typeof drawer.close === 'function') drawer.close();
        return;
      }
      if (event.key !== 'Tab') return;
      var list = focusables(inner());
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      var active = document.activeElement;
      if (!inner().contains(active)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus();
      } else if (event.shiftKey && active === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    });

    /* Quantity, plus/minus and remove re-render silently in the vendor drawer: say what happened. */
    function arm(event) {
      var t = event.target;
      if (t.closest && (t.closest('.m-quantity__button') || t.closest('m-cart-remove-button') || (event.type === 'change' && t.matches('[name="updates[]"]')))) pendingAnnounce = true;
    }
    drawer.addEventListener('click', arm);
    drawer.addEventListener('change', arm);

    var items = drawer.querySelector('[data-minimog-cart-items]');
    if (items) {
      new MutationObserver(function () {
        restore();
        clearTimeout(announceTimer);
        announceTimer = setTimeout(function () {
          if (!pendingAnnounce || !status) return;
          pendingAnnounce = false;
          var total = 0;
          drawer.querySelectorAll('input[name="updates[]"]').forEach(function (input) { total += parseInt(input.value, 10) || 0; });
          var subtotal = drawer.querySelector('[data-cart-subtotal-price]');
          var money = subtotal ? subtotal.textContent.replace(/\s+/g, ' ').trim() : '';
          status.textContent = total === 0 ? 'Cart updated. Your cart is empty.' : 'Cart updated. ' + total + (total === 1 ? ' item' : ' items') + (money ? ', subtotal ' + money : '') + '.';
        }, 400);
      }).observe(items, { childList: true, subtree: true });
    }
  }

  /* A11Y-17: header predictive search is a combobox with a labelled results list, arrow keys and Escape. */
  function search() {
    var popup = document.querySelector('[data-search-popup]');
    var input = popup && popup.querySelector('[data-search-input]');
    var predictive = popup && popup.querySelector('predictive-search');
    if (!input) return;
    var label = input.getAttribute('aria-label') || 'Search';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-label', label);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    input.setAttribute('aria-expanded', 'false');

    var live = document.createElement('p');
    live.className = 'tt-sr-only';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    popup.appendChild(live);

    var opener = null;
    var active = -1;
    document.addEventListener('focusin', function (event) {
      if (!popup.contains(event.target)) opener = event.target;
    });

    function options() { return Array.prototype.slice.call(popup.querySelectorAll('[role="option"]')); }
    function select(index) {
      var list = options();
      list.forEach(function (option) { option.setAttribute('aria-selected', 'false'); });
      active = list.length ? (index + list.length) % list.length : -1;
      if (active < 0) {
        input.removeAttribute('aria-activedescendant');
        return;
      }
      list[active].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', list[active].id);
      list[active].scrollIntoView({ block: 'nearest' });
    }

    function sync() {
      /* The vendor puts role=option on the li around a link: an option must not contain an interactive child, so the link becomes the option. */
      popup.querySelectorAll('li[role="option"]').forEach(function (li) {
        var link = li.querySelector('a');
        if (!link) return;
        link.id = li.id;
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', li.getAttribute('aria-selected') || 'false');
        li.removeAttribute('id');
        li.removeAttribute('aria-selected');
        li.setAttribute('role', 'presentation');
      });
      var lists = popup.querySelectorAll('ul[role="group"], ul[role="listbox"]');
      var ids = [];
      lists.forEach(function (ul, i) {
        ul.setAttribute('role', 'listbox');
        if (!ul.id) ul.id = 'tt-search-list-' + i;
        var heading = ul.previousElementSibling;
        if (heading && heading.id) ul.setAttribute('aria-labelledby', heading.id); else ul.removeAttribute('aria-labelledby');
        ids.push(ul.id);
      });
      if (ids.length) input.setAttribute('aria-controls', ids.join(' ')); else input.removeAttribute('aria-controls');
      var open = !!predictive && predictive.hasAttribute('open');
      input.setAttribute('aria-expanded', String(open));
      if (!open) select(-1);
      var count = popup.querySelectorAll('[role="option"], .m-search-result__products-list a').length;
      live.textContent = open && predictive.hasAttribute('results') ? (count ? count + (count === 1 ? ' suggestion' : ' suggestions') + ' available' : 'No suggestions') : '';
    }
    if (predictive) {
      new MutationObserver(sync).observe(predictive, { attributes: true, attributeFilter: ['open', 'results'], childList: true, subtree: true });
    }

    input.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (!options().length) return;
        event.preventDefault();
        select(active < 0 ? (event.key === 'ArrowDown' ? 0 : -1) : active + (event.key === 'ArrowDown' ? 1 : -1));
      } else if (event.key === 'Enter' && active >= 0) {
        var link = options()[active] && options()[active].querySelector('a');
        if (link) {
          event.preventDefault();
          window.location.href = link.href;
        }
      }
    });

    function closeAll() {
      var open = document.querySelectorAll('m-search-popup[open]');
      if (!open.length) return false;
      open.forEach(function (el) { if (typeof el.closeSearchPopup === 'function') el.closeSearchPopup(); });
      if (window.MinimogEvents && window.MinimogTheme) window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.closeSearchPopup);
      if (usable(opener)) opener.focus({ preventScroll: true });
      return true;
    }
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || document.getElementById('MinimogCartDrawer') && document.getElementById('MinimogCartDrawer').classList.contains('m-cart-drawer--active')) return;
      if (closeAll()) event.preventDefault();
    });
    var returnFocus = new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.target.hasAttribute('open')) return;
        var current = document.activeElement;
        if ((!current || current === document.body || popup.contains(current)) && usable(opener)) opener.focus({ preventScroll: true });
      });
    });
    document.querySelectorAll('m-search-popup').forEach(function (el) { returnFocus.observe(el, { attributes: true, attributeFilter: ['open'] }); });
  }

  /* REQ-064 AC4: arrival dates = today plus business days (Sat/Sun skipped), from data-min/data-max on the PDP buy box. */
  function arrival() {
    var e = document.querySelector('[data-tt-arrive]');
    if (!e) return;
    function f(n) {
      var d = new Date();
      while (n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; }
      return d.toLocaleDateString('en-AU', { weekday: 'short' }) + ', ' + d.toLocaleDateString('en-AU', { day: 'numeric', month: 'short' });
    }
    e.querySelector('[data-tt-big]').textContent = 'Arrives ' + f(+e.dataset.min) + ' to ' + f(+e.dataset.max);
  }

  /* REQ-046: the mobile menu drawer takes focus on open, keeps Tab inside, and hands focus back to the toggle on close. */
  function menuDrawer() {
    var drawer = document.getElementById('m-menu-drawer'), toggle = document.querySelector('.tt-menu-toggle'), wasOpen = false;
    if (!drawer || !toggle) return;
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('open'), tries = 0;
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      if (isOpen) (function focusFirst() {
        var list = focusables(drawer);
        if (list.length) list[0].focus({ preventScroll: true });
        if (!drawer.contains(document.activeElement) && drawer.classList.contains('open') && tries++ < 10) setTimeout(focusFirst, 50);
      }());
      else if (drawer.contains(document.activeElement)) toggle.focus();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('open')) return;
      var list = focusables(drawer), first = list[0], last = list[list.length - 1], active = document.activeElement;
      if (first && (!drawer.contains(active) || active === (e.shiftKey ? first : last))) {
        e.preventDefault();
        (e.shiftKey ? last : first).focus();
      }
    });
  }

  /* REQ-089: shipping amounts in the shopper's currency: AUD cents x Shopify.currency.rate, as checkout converts.
     [data-tt-money] with data-total is the cart free-shipping bar, without it the service strip offer. */
  function money() {
    var c = window.Shopify && Shopify.currency || {};
    function run() {
      document.querySelectorAll('[data-tt-money]:not([data-done])').forEach(function (e) {
        var d = e.dataset, n = d.total ? undefined : 0, v = d.cur == c.active ? +d.ttMoney : d.cur == 'AUD' && Math.ceil(d.ttMoney * c.rate),
          f = new Intl.NumberFormat('en', { style: 'currency', currency: c.active, currencyDisplay: 'narrowSymbol', minimumFractionDigits: n, maximumFractionDigits: n });
        d.done = 1;
        if (!v) return;
        if (!d.total) return e.textContent = f.format(Math.ceil(v / 100));
        e.firstElementChild.textContent = v > d.total ? 'Add ' + f.format((v - d.total) / 100) + ' more for free shipping to ' + d.country + '.' : 'Free shipping to ' + d.country + ' on this order.';
        e.lastElementChild.firstElementChild.style.width = Math.min(100, 100 * d.total / v) + '%';
        e.hidden = false;
      });
    }
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    money();
    menuDrawer();
    arrival();
    cartLabels();
    cartDrawer();
    search();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
}());
